export const SET_ACTIVE_USER = "SET_ACTIVE_USER";
export const SET_ACTIVE_MODAL = "SET_ACTIVE_MODAL";
export const SET_ACTIVE_SIDE_NAV = "SET_ACTIVE_SIDE_NAV";
export const SET_ACTIVE_LAYOUT = "SET_ACTIVE_LAYOUT";
